import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['featureToggle', 'helplineCases', 'locationDepartmentForm']

  connect() {
    this.resetCopyLinkHandler();
  }

  copyLink() {
    var copyText = $('#copy-link-input');

    copyTextToClipboard(copyText.val());
    $('#ico-copy-link').hide();
    $('#ico-copy-success').show();
    setTimeout(() => { this.resetCopyLink() }, 2000);
  }

  resetCopyLinkHandler() {
    $('#feedback-capture-modal').on('hidden.bs.modal', function () {
      this.resetCopyLink();
    });
  }

  resetCopyLink() {
    $('#copy-paste-message').addClass('d-none');
    $('#ico-copy-link').show()
    $('#ico-copy-success').hide();
  }

  helplineFeatureToggle(event) {
    var toggleValue = event.target.checked ? 'collect_cases' : 'disabled'
    $(this.helplineCasesTarget).val(toggleValue)
    this.featureToggleTarget.submit()
  }

  selectText(event) {
    event.preventDefault()
    const inputElement = event.target;

    if (inputElement && inputElement.select) {
      inputElement.removeAttribute('disabled');
      inputElement.select()
      inputElement.setSelectionRange(0, 99999);
      inputElement.setAttribute('disabled', 'disabled');

    }
  }

  disableField(event) {
    event.target.removeAttribute('disabled');
  }
}
